import api from './api';

export const getKraTemplates = (params = {}) => api.get('/kra/templates', { params });

export const getKraTemplate = (id) => api.get(`/kra/templates/${id}`);

export const createKraTemplate = (data) => api.post('/kra/templates', data);

export const addKraItem = (templateId, data) => api.post(`/kra/templates/${templateId}/items`, data);

export const updateKraItem = (templateId, itemId, data) =>
  api.put(`/kra/templates/${templateId}/items/${itemId}`, data);

export const deactivateKraItem = (templateId, itemId) =>
  api.delete(`/kra/templates/${templateId}/items/${itemId}`);

export const publishKraTemplate = (templateId) => api.post(`/kra/templates/${templateId}/publish`);

export const deleteKraTemplate = (templateId) => api.delete(`/kra/templates/${templateId}`);

// Only works on an already-archived template, and only if no monthly cycle
// was ever generated from it - see permanently_delete_template's docstring.
// This is for clearing out drafts/mistakes, not undoing real appraisal history.
export const permanentlyDeleteKraTemplate = (templateId) => api.delete(`/kra/templates/${templateId}/permanent`);

// Clones every active item (+ scoring rules + external-department
// requirements) from an existing template into a new draft. Pass
// target_employee_id to turn a shared department/role template into a
// one-employee personal override without touching the shared one everyone
// else still uses; omit department_id/role/target_employee_id to inherit
// them all from the source.
export const cloneKraTemplate = (templateId, data) => api.post(`/kra/templates/${templateId}/clone`, data);

// Overwrites the scoring rules on every active item in the template with
// the same set - the fix for items that never got one (most commonly:
// Excel-imported items, which the import deliberately doesn't guess a
// scoring rule for) blocking publish with "no scoring rule defined".
export const applyScoringRulesToAllItems = (templateId, scoringRules) =>
  api.post(`/kra/templates/${templateId}/apply-scoring-rules`, { scoring_rules: scoringRules });

// Excel import - preview parses the uploaded file and returns a per-sheet
// breakdown without saving anything; commit persists the (possibly HR-edited)
// result as new draft templates. See kra_routes.py's "EXCEL IMPORT PARSING"
// section for why nothing here is auto-corrected.
export const importTemplatePreview = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  // No explicit Content-Type - see api.js's 2026-09-13 comment on why
  // setting it here breaks the multipart boundary axios/the browser add
  // automatically for a FormData body.
  return api.post('/kra/templates/import/preview', formData);
};

export const importTemplateCommit = (payload) => api.post('/kra/templates/import/commit', payload);
